import "./Main.css";
import ABBIrb2400L from "./CardSections/ABBIrb2400L";
import ABBIrb1400 from "./CardSections/ABBIrb1400";
import IRC5ABBIrb1600 from "./CardSections/IRC5ABBIrb1600";
import X2ABBIrb1600 from "./CardSections/X2ABBIrb1600";

const Main = () => {
  return (
    <div className="pricesMain">
      <IRC5ABBIrb1600></IRC5ABBIrb1600>
      <X2ABBIrb1600></X2ABBIrb1600>
      <ABBIrb1400></ABBIrb1400>
      <ABBIrb2400L></ABBIrb2400L>
    </div>
  );
};

export default Main;
